import {
    Card,
    CardBody,
    
    Typography,
    
  } from "@material-tailwind/react";

const Benifitbox = () => {
    return (
        <div className="maincontainer relative overflow-x-clip pb-20 sm:pb-20 bg-blue-100">
          <div className="container sm:container mx-auto md:container md:auto">
            <div className="headlinesboix lg:pt-5 lg:pb-10  flex justify-center">
              <div className="biglines  mt-10">
                <h1 className="fonting mx-auto max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
                    Advantages of Registering for GST
                </h1>
              </div>
            </div>
            <div className="contentbox w-full mx-auto mt-5">
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                    Removal of Several Taxes
                  </Typography>
                  <Typography className="text-lg">
                    One benefit of the Goods and Services Tax (GST) is the elimination of several indirect taxes. There are so many responsibilities that have been replaced. Excise, CENVAT, sales tax, service tax, octroi, turnover tax, and other taxes are no longer applicable and have all been combined into one single tax known as GST.
                  </Typography>
                </CardBody>
              </Card>
              {/** second card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Increasing Your Money Savings
                  </Typography>
                  <Typography className="text-lg">
                  For the average man, double charging has been eliminated in the system thanks to GST applicability. This has helped the average person save more money by lowering the cost of products and services.
                  </Typography>
                </CardBody>
              </Card>
              {/** third card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Ease of Business
                  </Typography>
                  <Typography className="text-lg">
                  "One Nation, One Tax" was the concept introduced by TGST. The states' previous unfavorable rivalry has benefited organizations looking to conduct interstate commerce.
                  </Typography>
                </CardBody>
              </Card>
              {/** fourth card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                    Cascading Effect Diminishment
                  </Typography>
                  <Typography className="text-lg">
                  GST is relevant at every level, from assembly to use. Advantages for tax credits are being provided at every link in the process. In the previous instance, tax was paid on the whole amount at each stage, and the margin was added. Businesses are using the Input Tax Credit under the GST, and they are only paying tax on the amount of value added. The cascading effect of taxes has been lessened by GST, which has decreased the product's cost.
                  </Typography>
                </CardBody>
              </Card>
              {/** fifith card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Increased Employment
                  </Typography>
                  <Typography className="text-lg">
                  The demand for most, if not all, products has increased as a result of GST's reduction in product costs. The work diagram has begun to rise in response to the expansion in supply and the expansion in demand.
                  </Typography>
                </CardBody>
              </Card>
              {/** sixth card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Growth in GDP
                  </Typography>
                  <Typography className="text-lg">
                  The production will rise in proportion to the demand. A higher Gross Domestic Product (GDP) results from this.
                  </Typography>
                </CardBody>
              </Card>
              {/** seventh card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Diminished Tax Evasion
                  </Typography>
                  <Typography className="text-lg">
                  The goods and services tax is a single tax that incorporates several previous taxes and is effective, yet there is a possibility of corruption and tax evasion.
                  </Typography>
                </CardBody>
              </Card>
              {/** eighth card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  A Product With Greater Competition
                  </Typography>
                  <Typography className="text-lg">
                  Since the GST eliminated the tax's cascading effect, high cost of logistics, and interstate tax, manufacturing has increased in intensity. Providing competitive as GST will take care of the business and consumer's descending effect of the tax, high log benefits, and interstate tax.
                  </Typography>
                </CardBody>
              </Card>
            </div>
            <div className="headlinesboix lg:pt-5 lg:pb-10  flex justify-center">
                <div className="biglines  mt-10">
                    <h1 className="fonting mx-auto text-center max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
                    Penalties for Failure to Comply

                    </h1>
                    <div className="explainboxpara w-full mt-5 text-lg">
                    
                        <p>
                        The deadline for filing all GST returns is the next month's 20th. The GST Act contains harsh penalties for breaking the rules and regulations. There is a fine for failing to register a business for GST when it comes within the jurisdiction. If the offender has not filed for GST registration and aims to evade paying taxes, the fine is 100% of the total amount owed. The total is the appropriate tax. or ten thousand rupees, whichever is more.

                        </p>
                    
                        <p className="mt-5 text-xl">
                        For those who select the configuration scheme even though they are not agreeable to it, there is also a reasonable penalty of 100% of the taxes owed or Rs. 10,000, whichever is larger. A 10% fine equal to the amount of taxes owed is imposed on any offender who fails to pay their taxes on time or makes short installments out of honest mistake. It cannot be less than Rs 10,000 in total. If the GST invoice is not provided, the offending party will be liable for the whole amount owed in taxes, or Rs. 10,000. whichever is more elevated.

                        </p>
                    </div>
                </div>
            </div>
            <div className="headlinesboix lg:pt-5 lg:pb-10  flex justify-center">
                <div className="biglines  mt-10">
                    <h1 className="fonting mx-auto text-center max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
                    What is the GSTIN?

                    </h1>
                    <div className="explainboxpara w-full mt-5 text-lg">
                    
                        <p>
                            <ul className="lists mx-4">
                                <li className="mt-3">The 15-digit alphanumeric GSTIN is specific to each Firm, Company, or Individual that has enrolled in the GST program.                                </li>
                                <li className="mt-3">The government has promised that the GST will only be available digitally, resulting in greater openness and decreased corruption.                                </li>
                                <li className="mt-3">The state code, which is determined by the 2011 census, is represented by the first two digits of the GSTIN.                                </li>
                                <li className="mt-3">The entity's PAN number is represented by the next ten digits.                                </li>
                                <li className="mt-3">The 14th digit is Z by default.</li>
                                <li className="mt-3">The checksum digit is the fifteenth or last digit. It follows logically from the figure used in the computation of the remaining 14 digits.                                </li>
                            </ul>
                        </p>
                    
                        {/* <p className="mt-5 text-xl">
                        It takes 15 to 30 working days (approx.) to finish the Limited Liability Partnership Registration procedure. The timeline may vary depending on responses from the ROC department.
                        </p> */}
                    </div>
                </div>
            </div>
          </div>
        </div>
      );
}

export default Benifitbox